export const EventName = {
  EventAddModalOpening: "EventAddModalOpening",
  EventDetailModalOpening: "EventDetailModalOpening",
  WorkTimeAddOffcanvasOpening: "WorkTimeAddOffcanvasOpening",
  VoucherEditModalOpening: "VoucherEditModalOpening",
  VoucherAddModalOpening: "VoucherAddModalOpening",
  CustomerReferrerAddModalOpening: "CustomerReferrerAddModalOpening",
  CustomerAddOffcanvasOpening: "CustomerAddOffcanvasOpening",
  CustomerDetailOffcanvasOpening: "CustomerDetailOffcanvasOpening",
  NotiSendOffcanvasOpening: "NotiSendOffcanvasOpening",
  DiaryAddOffcanvasOpening: "DiaryAddOffcanvasOpening",
  ProgramOrderEditModalOpening: "ProgramOrderEditModalOpening",
  ImageGalleryModalOpening: "ImageGalleryModalOpening",
  PermissionModalOpening: "PermissionModalOpening",
  SignUpModal1Opening: "SignUpModal1Opening",
  LeftMenuOffcanvasOpening: "LeftMenuOffcanvasOpening",
  LeftMenuForCustomerOffcanvasOpening: "LeftMenuForCustomerOffcanvasOpening",
  LeftMenuOffcanvasClosing: "LeftMenuOffcanvasClosing",
  LeftMenuForCustomerOffcanvasClosing: "LeftMenuForCustomerOffcanvasClosing",
};

export const Color = {
  green: "초록색",
  cyan: "시안색",
  brown: "갈색",
  blue: "파란색",
  red: "빨간색",
  rose: "장미색",
  coral: "코랄색",
  yellow: "노란색",
  violet: "바이올렛색",
};

// https://github.com/chmln/vue-wysiwyg#config-options
export const WysiwygOptions = {
  hideModules: {
    bold: false,
    italic: false,
    underline: false,
    justifyLeft: true,
    justifyCenter: true,
    justifyRight: true,
    headings: true,
    link: true,
    code: true,
    orderedList: true,
    unorderedList: false,
    image: true,
    table: true,
    removeFormat: true,
    separator: true,
  },
};
